import { tableControlSurfaceSx } from '@/features/shared/components/tableSystem/tablePanelSurfaceSx';
import type { SxProps, Theme } from '@/ui/primitives';

export const coverageHistoryHeaderCellSurfaceSx = tableControlSurfaceSx satisfies SxProps<Theme>;

export const coverageHistoryMetricValueSurfaceSx = tableControlSurfaceSx satisfies SxProps<Theme>;
